module.exports = __webpack_public_path__ + "static/media/grid.5636f163.svg";